<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="指标" prop="target">
                <el-select v-model="queryCondition.target" clearable placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in targetLists" :label="item.name" :value="item.tmCategoryId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="CQS Owner" prop="cqsOwner">
                <el-input v-model="queryCondition.cqsOwner" clearable style="width:100%" placeholder="按用户名模糊查询"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd">新增</el-button>
        <el-button size="mini" class="btn" type="danger" @click="onDel">删除</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="指标" field="target"></ux-table-column>
        <ux-table-column align="center" title="CQS Owner" field="cqsOwner"></ux-table-column>
        <ux-table-column align="center" title="更新人" field="updator"></ux-table-column>
        <ux-table-column align="center" title="更新时间" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showDetailDialog" title="新增指标CQS Owner" append-to-body width="40%" :close-on-click-modal="false" @close="closeDialog">
      <el-form :model="detailForm" ref="detailForm" label-position="right" label-width="120px">
        <el-row :gutter="20">
          <el-form-item label="指标" prop="target">
            <el-select v-model="detailForm.target" clearable placeholder="请选择" style="width:100%">
              <el-option :key="index" v-for="(item,index) in targetLists" :label="item.name" :value="item.tmCategoryId"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="CQS Owner" prop="cqsOwner">
            <el-input v-model="detailForm.cqsOwner" clearable style="width:100%"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="onSave" type="primary">保存</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
export default {
  name: '',
  components: {
    IcSelect,
  },
  data() {
    return {
      targetLists: [],
      queryCondition: {},
      detailForm:{},
      showDetailDialog: false,
      tableData: [
        {
          target: "AAA",
          cqsOwner: "Liliy1 Wang",
          updator: "Bill Zhang",
          updateDate: "2021-07-01",
        }
      ],
      formData: null,
    }
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      this.$refs.plxTable.reloadData(this.tableData)
    },
    onReset() {

    },
    onAdd() {
      this.showDetailDialog=true
    },
    onDel() {

    },
    onSave() {

    },
    closeDialog(){
      this.showDetailDialog=false
    }
  },
}
</script>
<style scoped >
</style>
